import React from 'react'
import { FlowGrid, H2, LayoutBand, Separator, usePageWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

import OfferColorProvider from './ColorProvider'
import FamilyTreeCard from './offer-cards/FamilyTreeCard'
import HelpCard from './offer-cards/HelpCard'
import LocationsCard from './offer-cards/LocationsCard'
import MemoriesCard from './offer-cards/MemoriesCard'
import RecordsCard from './offer-cards/RecordsCard'
import RootsTechCard from './offer-cards/RootsTechCard'

/**
 * OffersSection accepts as children any number of OfferCard components, or variants found in the offers directory.
 * It provides a way to apply a common color to all cards without needing to pass the color prop to each one.
 * If no children are provided, the component will include all existing offer cards.
 */
export default function OffersSection({ color, backgroundColor, iconPattern, children }) {
  const { t } = useTranslation()
  const isMobile = usePageWidth()({ default: true, xl: false })

  return (
    <LayoutBand marginY={isMobile ? 'xl' : 'xxl'}>
      <H2 size={isMobile ? 'H2' : 'H3'} centered supplementary>
        {t('apac.nlihp.offers-section.heading', 'What FamilySearch Offers')}
      </H2>
      <Separator size="lg" />
      <OfferColorProvider color={color} backgroundColor={backgroundColor} iconPattern={iconPattern}>
        <FlowGrid columnCount={isMobile ? 1 : 3} gutters={isMobile ? 'md' : 'lg'}>
          {children || [
            <FamilyTreeCard key="family-tree-card" />,
            <RecordsCard key="records-card" />,
            <MemoriesCard key="memories-card" />,
            <RootsTechCard key="rootstech-card" />,
            <LocationsCard key="locations-card" />,
            <HelpCard simple key="help-card" />,
          ]}
        </FlowGrid>
      </OfferColorProvider>
    </LayoutBand>
  )
}
